// extracted by mini-css-extract-plugin
export default {"hideTooltip":"P9-z","fadeIn":"Q9-z","delay":"R9-z","recommendedSizeTooltip":"S9-z"};